import useSWR from "swr";

export const useFetchActiveLineAccountsCount = (restaurantId: string) => {
  const { data: activeLineAccountsCount, error, isLoading } = useSWR<number>(`external_api/line/active-accounts/count/?restaurantId=${restaurantId}`)
  return { activeLineAccountsCount, isLoading, error };
};